import { Pipe, PipeTransform } from "@angular/core";

import { MedTableColumnConfig } from "../types";
import { MedTableSettingsLocal } from "../types.local";

@Pipe({
  name: "getCellMaxWidth",
})
export class GetCellMaxWidthPipe implements PipeTransform {
  transform({ maxWidth }: MedTableColumnConfig, settingsLocal: MedTableSettingsLocal): string {
    return maxWidth || settingsLocal.colMaxWidth;
  }
}
